export default function (target) {
  const link = document.createElement("a");
  link.href = target;
  link.target = "_blank";
  link.download = "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
